var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "txt-item"
  }, [_c('v-row', {
    staticClass: "mx-n8px my-0"
  }, [this.$slots['title'] ? _c('v-col', {
    staticClass: "px-8px py-0",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('p', {
    class: 'txt txt--xl txt--dark font-weight-medium ' + _vm.titleClass
  }, [_vm._t("title")], 2)]) : _vm._e(), this.$slots['default'] ? _c('v-col', {
    staticClass: "px-8px py-0",
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('p', {
    staticClass: "txt txt--xl"
  }, [_vm._t("default")], 2)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }